import { controlToastState } from "risa-oasis-ui_v2";
import { refetchClinicalAttachment } from "../../../../api/postCall/refetchClinicalAttachment";
import { logError } from "../../../../utils/customLogger";

/**
 * Handles the refetch action for clinical attachment (fire and forget)
 * @param identifier - The order identifier
 * @param onInitiate - Callback to execute immediately after initiating refetch
 */
export const onRefetch = (identifier: string, onInitiate: () => void): void => {
  if (!identifier) {
    controlToastState("refetch-attachment-no-identifier");
    return;
  }

  // Show in-progress toast and execute callback immediately
  controlToastState("refetch-attachment-in-progress");
  onInitiate();

  // Fire and forget - don't await the response
  refetchClinicalAttachment({ identifier })
    .then((response) => {
      if (!response.success) {
        // Only log errors, don't show toast since modal is already closed
        console.error("Refetch clinical attachment failed:", response.message);
      }
    })
    .catch((error) => {
      logError(error as Error, "Error refetching clinical attachment");
    });
};
